import React, {useEffect, useRef, useState } from 'react';
import {AnimatePresence, motion} from 'framer-motion';
import {useDispatch, useSelector} from "react-redux";
import {MenuModalOpen, mainSelector, InfoModalOpen, AGModalOpen} from "../../store/slices/main.slice";
import {useNavigate} from "react-router-dom";
import Header from "../layout/Header";
import {useTranslation} from "react-i18next";
import {changeLanguageSafe} from "../../i18nSwitch";

const MenuModalRoot = () => {
    const { t, i18n }: any = useTranslation('translation');
    const dispatch: any = useDispatch();
    const { menuModal, infoModal } = useSelector(mainSelector);
    const navigate = useNavigate();
    const [isOpen, setIsOpen] = useState(menuModal.open)
    const [selectedPolicy, setSelectedPolicy] = useState<'privacy' | 'legal'>('privacy')

    useEffect(() => {
        setIsOpen(menuModal.open)
    }, [menuModal]);

    const onClose = () => {
        dispatch(AGModalOpen(false))
        dispatch(MenuModalOpen(false))
        dispatch(InfoModalOpen(false))
    }

    const goToCollezione = () => {
        dispatch(AGModalOpen(false))
        dispatch(MenuModalOpen(false))
        dispatch(InfoModalOpen(false))
        navigate('/collezione')
    }

    const goToPercorsi = () => {
        dispatch(AGModalOpen(false))
        dispatch(MenuModalOpen(false))
        dispatch(InfoModalOpen(false))
        navigate('/percorsi')
    }

    const goToPalazzo = () => {
        dispatch(AGModalOpen(false))
        dispatch(MenuModalOpen(false))
        dispatch(InfoModalOpen(false))
        navigate('/palazzo')
    }

    // Handle scrolling
    const [showScrollUp, setShowScrollUp] = useState(false);
    const [showScrollDown, setShowScrollDown] = useState(false);
    const scrollableDivRef = useRef(null);

    const checkScroll = () => {
        const div = scrollableDivRef.current;
        if (!div) return;

        //@ts-ignore
        const maxScroll = div.scrollHeight - div.offsetHeight;
        //@ts-ignore
        setShowScrollUp(div.scrollTop > 0);
        //@ts-ignore
        setShowScrollDown(div.scrollTop < maxScroll);
    };

    useEffect(() => {
        const div = scrollableDivRef.current;
        if (div) {
            const preventScroll = (e: any) => e.preventDefault();
            //@ts-ignore
            div.addEventListener('wheel', preventScroll, { passive: false });

            return () => {
                //@ts-ignore
                div.removeEventListener('wheel', preventScroll);
            };
        }
    }, []);

    useEffect(() => {
        checkScroll()
    }, [scrollableDivRef, infoModal, menuModal]);

    const scrollDown = () => {
        if (scrollableDivRef.current) {
            //@ts-ignore
            scrollableDivRef.current.scrollBy({ top: 100, behavior: 'smooth' });
        }
    };

    const scrollUp = () => {
        if (scrollableDivRef.current) {
            //@ts-ignore
            scrollableDivRef.current.scrollBy({ top: -100, behavior: 'smooth' });
        }
    };

    const Divider = () => {
        return (
            <div className="w-[90%] h-[1px] bg-accent my-[20px]"/>
        )
    }

    if(menuModal.open === true || infoModal.open === true) {
        return (
            <AnimatePresence>
                {menuModal.open === true && <motion.div
                    key="shapeModal-root"
                    className="fixed top-0 left-0 w-full h-full justify-center items-center z-[991] bg-[#e4dbd6] overflow-y-scroll"
                    initial={{height: 0}}
                    animate={{height: '100vh', transition: {duration: 0.25, delay: 0}}}
                    exit={{height: 0, transition: {duration: 0.25, delay: 0.10}}}
                    onClick={onClose}
                >
                    <motion.div
                        key="shapeModal-content"
                        className="w-[100vw] h-[100vh] bg-[#e4dbd6] flex flex-col items-center justify-center"
                        initial={{opacity: 0}}
                        animate={{opacity: 1, transition: {duration: 0.10, delay: 0.25}}}
                        exit={{opacity: 0, transition: {duration: 0.10, delay: 0}}}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <header className="absolute top-0 right-0 flex flex-row justify-between items-center w-full gap-[50px] h-[84px] sm:h-[60px] lg:h-[84px]">
                            <Header version="dark"/>
                        </header>
                        <div className="flex flex-col gap-[15px] sm:gap-[0px] lg:gap-[30px] w-max pb-0 sm:pb-[30px] mt-[-30px] lg:mt-0 lg:pb-0 h-full sm:h-max lg:h-full items-center justify-center">
                            <h2 onClick={goToCollezione} className="text-black text-2md sm:text-sm lg:text-xl font-untitledSans uppercase px-[100px] cursor-pointer">{t('ag.menu_collezione')}</h2>
                            <Divider/>
                            <h2 onClick={goToPalazzo} className="text-black text-2md sm:text-sm lg:text-xl font-untitledSans uppercase cursor-pointer">{t('ag.menu_palazzo')}</h2>
                            <Divider/>
                            <h2 onClick={goToPercorsi} className="text-black text-2md sm:text-sm lg:text-xl font-untitledSans uppercase cursor-pointer">{t('ag.menu_percorsi')}</h2>
                        </div>
                        <motion.footer
                            key="home-content-footer"
                            className="flex flex-row items-center h-max gap-[10px] pb-[120px] sm:pb-0 mt-[-60px] sm:mt-0 lg:pb-[30px]"
                            initial={{opacity: 1}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0, transition: {duration: 1}}}
                        >
                            <button onClick={() => changeLanguageSafe('it')} className={`text-black text-xs lg:text-base font-untitledSans hover:underline ${i18n.language === 'it' && 'underline'}`}>IT</button>
                            <div className="bg-black w-[3px] h-[3px] min-w-[3px] min-h-[3px] rounded-full"/>
                            <button onClick={() => changeLanguageSafe('en')} className={`text-black text-xs lg:text-base font-untitledSans hover:underline ${i18n.language === 'en' && 'underline'}`}>EN</button>
                            <div className="bg-black w-[3px] h-[3px] min-w-[3px] min-h-[3px] rounded-full"/>
                            <button onClick={() => changeLanguageSafe('de')} className={`text-black text-xs lg:text-base font-untitledSans hover:underline ${i18n.language === 'de' && 'underline'}`}>DE</button>
                            <div className="bg-black w-[3px] h-[3px] min-w-[3px] min-h-[3px] rounded-full"/>
                            <button onClick={() => changeLanguageSafe('fr')} className={`text-black text-xs lg:text-base font-untitledSans hover:underline ${i18n.language === 'fr' && 'underline'}`}>FR</button>
                        </motion.footer>
                    </motion.div>
                </motion.div>}
                {infoModal.open && (
                    <motion.div
                        key="shapeModal-root-info"
                        className="fixed top-0 left-0 w-full h-0 bg-[#e4dbd6] flex justify-center items-center z-[991] overflow-y-scroll lg:overflow-hidden"
                        initial={{height: 0}}
                        animate={{height: '100vh', transition: {duration: 0.25, delay: 0}}}
                        exit={{height: 0, transition: {duration: 0.25, delay: 0.10}}}
                        onClick={onClose}
                    >
                        <header className="absolute top-0 right-0 flex flex-row justify-between items-center w-full gap-[50px] h-[84px] sm:h-[60px] lg:h-[84px] z-[999]">
                            <Header version="dark"/>
                        </header>
                        <motion.div
                            key="shapeModal-content-info"
                            className="relative h-[100vh] flex flex-col lg:items-center lg:justify-center p-[20px] pt-[60px] lg:p-[60px] w-[90vw] lg:w-[70vw]"
                            initial={{opacity: 0}}
                            animate={{opacity: 1, transition: {duration: 0.10, delay: 0.25}}}
                            exit={{opacity: 0, transition: {duration: 0.10, delay: 0}}}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <div className="flex flex-col lg:flex-row gap-[30px]">
                                <section className="w-full lg:w-[50%]">
                                    <h2 className="text-black text-base lg:text-md font-untitledSans font-medium mb-[15px]">{t('ag.info_menu_links')}</h2>
                                    <a href="https://gndm.it/" target="_blank" className="text-black text-xs lg:text-sm font-untitledSans underline">gallerianazionalemarche.it</a>
                                    <div className="mt-[5px]">
                                        <span className="text-black text-xs lg:text-sm font-untitledSans">{t('ag.info_menu_condividi')}:</span>
                                        <div className="flex flex-row items-center gap-[20px] mt-[10px]">
                                            <a href="https://www.instagram.com/gnmarche/" target="_blank" rel="noopener noreferrer" className={`w-[32px] flex flex-col items-center justify-center`} style={{height: "32px"}}>
                                                <img src="/images/instragram-icon.png" alt="Instagram icon" className={`max-h-[32px] h-full w-[auto]`}/>
                                            </a>
                                            <a href="https://www.youtube.com/@GNMarche" target="_blank" rel="noopener noreferrer" className={`w-[32px] flex flex-col items-center justify-center`} style={{height: "32px"}}>
                                                <img src="/images/youtube-icon.png" alt="Youtube icon" className={`max-h-[32px] h-full w-[auto]`}/>
                                            </a>
                                            <a href="https://www.facebook.com/PalazzoDucaleUrbino?locale=it_IT" target="_blank" rel="noopener noreferrer" className={`w-[32px] flex flex-col items-center justify-center`} style={{height: "32px"}}>
                                                <img src="/images/facebook-icon.png" alt="Facebook icon" className={`max-h-[32px] h-full w-[auto]`}/>
                                            </a>
                                            <a href="https://x.com/GNMarche" target="_blank" rel="noopener noreferrer" className={`w-[32px] flex flex-col items-center justify-center`} style={{height: "32px"}}>
                                                <img src="/images/x-icon.png" alt="X icon" className={`max-h-[32px] h-full w-[auto]`}/>
                                            </a>
                                            <a href="https://www.tiktok.com/@gallerianazionalemarche?_r=1&_t=ZN-91VEWAydNQc" target="_blank" rel="noopener noreferrer" className={`w-[32px] flex flex-col items-center justify-center`} style={{height: "32px"}}>
                                                <img src="/images/tiktok-icon.png" alt="TikTok icon" className={`max-h-[32px] h-full w-[auto]`}/>
                                            </a>
                                        </div>
                                    </div>
                                    <Divider/>
                                    <h2 className="text-black text-base lg:text-md font-untitledSans font-medium mb-[15px]">{t('ag.info_menu_credits_title')}</h2>
                                    <p className="text-black text-xs lg:text-sm font-untitledSans mb-[5px]">{t('ag.info_menu_credits_text')}: <a href="https://www.taleormade.com/" target="_blank" className="underline">taleormade.com</a></p>
                                    <p className="text-black text-xs lg:text-sm font-untitledSans">{t('ag.info_menu_pm_text')}</p>
                                    <Divider/>
                                    <p onClick={() => setSelectedPolicy('privacy')} className="text-black text-xs lg:text-sm font-untitledSans mb-[5px] underline">{t('ag.info_menu_privacy')}</p>
                                    <p onClick={() => setSelectedPolicy('legal')} className="text-black text-xs lg:text-sm font-untitledSans underline">{t('ag.info_menu_legal')}</p>
                                </section>
                                <section className="overflow-hidden w-full lg:w-[50%] pb-safe md:pb-0">
                                    <div className="max-h-[450px]">
                                        <h2 className="text-base lg:text-md font-untitledSans font-medium mb-[10px]">{selectedPolicy === 'privacy' ? t('vt.info_menu_privacy_title') : t('vt.info_menu_legal_title')}</h2>
                                        <p onScroll={checkScroll} ref={scrollableDivRef} className="scrollable-div text-xs lg:text-sm font-untitledSans text-justify h-[380px] overflow-y-auto">{selectedPolicy === 'privacy' ? t('vt.info_menu_privacy_text') : t('vt.info_menu_legal_text')}</p>
                                    </div>
                                    <section className="mt-[20px] flex flex-row items-center justify-between mb-[40px] lg:mb-0">
                                        {!showScrollUp && <div/>}
                                        {showScrollUp && <button onClick={scrollUp} className="text-black text-xxs lg:text-xs font-untitledSans font-bold h-[2opx] cursor-pointer">{t('ag.global_read_less')}</button>}
                                        {showScrollDown && <button onClick={scrollDown} className="text-black text-xxs lg:text-xs font-untitledSans font-bold h-[2opx] cursor-pointer">{t('ag.global_read_more')}</button>}
                                    </section>
                                </section>
                            </div>
                        </motion.div>
                    </motion.div>
                )}
            </AnimatePresence>
        );
    }

    return null
};

export default MenuModalRoot;
